import React from "react";
import {
  Typography,
  Checkbox,
  Button,
  Grid,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

export const FILTERS_TITLES = [
  "position",
  "function",
  "ageGroup",
  "seniority",
  "manager",
  "nationality",
  "sex",
  "management",
  "department",
  "workplaceAlt",
  "managementCostCenter",
  "workMode",
  "category",
  "businessUnit",
];

const FiltersSelection = (props) => {

  const {
    data,
    handleClick,
    handleSubmit,
  } = props;

  return (
    <div style={{ margin: 20, display: 'flex', flexDirection: 'column' }}>
      <Typography className="whiteText" align="center" style={{ fontSize: 20 }}>
        {getLocalizedString("filters")}
      </Typography>
      <Grid container style={{ padding: '10px 0px' }}>
        {
          Object.keys(data).map((filterName, index) => {
            return (
              <Grid container item xs={12} sm={6} md={4} lg={3} key={index}>
                <div
                  style={{ display: "flex", alignItems: "center", cursor: "pointer", paddingRight: 20 }}
                  onClick={() => handleClick(!Boolean(data[filterName]), filterName)}
                >
                  <Checkbox checked={data[filterName]} />
                  <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
                    {getLocalizedString(FILTERS_TITLES[index])}
                  </Typography>
                </div>
              </Grid>
            )
          })
        }
      </Grid>
      <Button
        className="whiteText"
        variant="contained"
        onClick={handleSubmit}
        style={{ width: 250, margin: '0 auto' }}
      >
        {getLocalizedString("searchLabel")}
      </Button>
    </div>
  );
}

export default FiltersSelection;